// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"slideshow___kU5mf"};